import { Link, Navigate, useLocation } from 'react-router';
import { personaHome, useSession } from '@/app/session';
import { PageHeader } from '@/components/shell/PageHeader';
import { EmptyState } from '@/components/shell/states';
import { buttonVariants } from '@/components/ui/button';

/** "/" goes to the persona home. */
export function PersonaHomeRedirect() {
  const { me } = useSession();
  return <Navigate to={personaHome(me?.persona)} replace />;
}

export function NotFoundPage() {
  const { me } = useSession();
  const location = useLocation();
  return (
    <>
      <PageHeader title="This page does not exist" description={<span className="break-all">{location.pathname}</span>} />
      <EmptyState
        className="mt-6"
        title="Nothing is served at this address."
        action={<Link to={personaHome(me?.persona)} className={buttonVariants({ variant: 'outline' })}>Go to your home</Link>}
      />
    </>
  );
}

/**
 * Honest placeholders for screens that arrive in a later milestone. They
 * exist so the five persona-home links never 404 and the tab title is right.
 */
export function NotYetPage({ title, description, headline, detail }: { title: string; description?: string; headline: string; detail: string }) {
  return (
    <>
      <PageHeader title={title} description={description} />
      <EmptyState className="mt-6" title={headline} description={detail} />
    </>
  );
}
